import React from 'react'
import { styled } from '@mui/material/styles'
import Modal from '@mui/material/Modal'
import './Popup.css'
import Backdrop from '@mui/material/Backdrop'
import Fade from '@mui/material/Fade'

const PREFIX = 'Popup'

const classes = {
    modal: `${PREFIX}-modal`,
    paper: `${PREFIX}-paper`,
}

const StyledModal = styled(Modal)(({ theme }) => ({
    [`&.${classes.modal}`]: {
        display: 'flex',
        padding: theme.spacing(1),
        alignItems: 'center',
        justifyContent: 'center',
    },

    [`& .${classes.paper}`]: {
        width: '100%',
        maxWidth: '46rem',
    },
}))

const Popup = ({ open, handleClose, children, modaltitle }) => {
    return (
        <StyledModal
            disablePortal
            disableEnforceFocus
            disableAutoFocus
            open={open}
            className={classes.modal}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            <Fade in={open}>
                <div className={classes.paper}>
                    <div className="modal fade show custom-modal">
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h4 className="modal-title">
                                        {modaltitle}
                                    </h4>
                                    <button
                                        id="popup_close"
                                        type="button"
                                        className="close"
                                        onClick={handleClose}
                                    >
                                        <i className="fa fa-times"></i>
                                    </button>
                                </div>
                                <div className="modal-body cm-body">
                                    {children}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fade>
        </StyledModal>
    )
}

export default Popup
